<div class="faq-container">
  <div class="faq-search-layout">
    <input
      type="text"
      class="form-control"
      placeholder="Search by keyword"
      name="faqsearch"
      [(ngModel)]="faqSearchText"
      (ngModelChange)="updateFilteredItems()"
    />
    <span><i class="material-icons search-icon">search</i></span>
  </div>

  <div class="faq-section">
    <div class="faq-entries">
      <div *ngFor="let item of filteredItems; let i = index" class="faq-entry">
        <button
          type="button"
          class="faq-toggle"
          (click)="toggleFaq(item)"
          [attr.aria-expanded]="item.isOpen"
          [attr.aria-controls]="'faq-content-' + i"
        >
          <span class="faq-icon">
            <em *ngIf="!item.isOpen" class="material-icons"
              >keyboard_arrow_down</em
            >
            <em *ngIf="item.isOpen" class="material-icons"
              >keyboard_arrow_up</em
            >
          </span>

          <span
            [innerHTML]="item.question | faqhighlight : faqSearchText"
          ></span>
        </button>

        <div
          [attr.id]="'faq-content-' + i"
          class="faq-content"
          [class.expanded]="item.isOpen"
          [attr.aria-hidden]="!item.isOpen"
        >
          <div
            class="faq-text"
            [innerHTML]="item.answer | faqhighlight : faqSearchText"
          ></div>

          <div
            class="faq-image-container"
            *ngIf="item.faqImage && item.faqImage.url"
          >
            <img
              [src]="item.faqImage.url"
              class="faq-answer-image"
              alt="FAQ illustration"
            />
          </div>
        </div>
      </div>

      <div class="not-found" *ngIf="filteredItems.length == 0">
        NO DATA FOUND
      </div>
    </div>
  </div>
</div>
